'use es6';

import { ACTIVE_CURRENCY_CODE_UPDATED, PHONE_NUMBERS_RECEIVED, PUBLIC_FEATURE_FLAGS_RECEIVED } from 'pricing-pages-unified-ui/constants/ActionTypes';
import CountryToCurrency from 'self-service-api/constants/CountryToCurrency';
import { getPublicMetaData } from 'pricing-pages-unified-ui/api/public-only/PublicMetaDataApi';
import { FetchPromotionsActions } from '../PromotionActions';
import { FetchRequiredOnboardingActions } from '../RequiredOnboardingActions';
import { FetchCountryActions } from '../CountryActions';
import { createRequestActions, createRequestTypes } from '../RequestActions';
export const FetchPublicMetaDataRequestTypes = createRequestTypes('PUBLIC_META_DATA');
export const FetchPublicMetaDataActions = createRequestActions(FetchPublicMetaDataRequestTypes); // temp formatting until reponse comes back this way from EE to match with in-app onboarding response

const formatRequiredOnboarding = payload => {
  const formattedObj = {};
  Object.keys(payload).map(apiName => formattedObj[apiName] = {
    apiName,
    onboardingApiName: payload[apiName],
    onboardingRequired: true
  });
  return formattedObj;
};

export const fetchPublicMetaData = () => {
  return dispatch => {
    dispatch(FetchPublicMetaDataActions.request());
    dispatch(FetchPromotionsActions.request());
    dispatch(FetchRequiredOnboardingActions.request());
    return getPublicMetaData().then(resp => {
      dispatch(FetchPublicMetaDataActions.receive());
      const {
        country,
        promotions,
        requiredOnboarding,
        phoneNumbers,
        featureFlags
      } = resp;
      const formattedRequiredOnboarding = formatRequiredOnboarding(requiredOnboarding); // TODO: once in-app can get countryCode too,
      // just use countryCode instead of full country string

      dispatch(FetchCountryActions.receive({
        country
      })); // TODO: Get currency from this endpoint too so we can kill this map

      const currency = CountryToCurrency[country];

      if (currency) {
        dispatch({
          type: ACTIVE_CURRENCY_CODE_UPDATED,
          payload: {
            currency
          }
        });
      }

      dispatch(FetchPromotionsActions.receive(promotions));
      dispatch(FetchRequiredOnboardingActions.receive({
        requiredOnboarding: formattedRequiredOnboarding
      }));
      dispatch({
        type: PHONE_NUMBERS_RECEIVED,
        payload: {
          phoneNumbers
        }
      });
      dispatch({
        type: PUBLIC_FEATURE_FLAGS_RECEIVED,
        payload: {
          featureFlags
        }
      });
    }).catch(error => {
      dispatch(FetchPublicMetaDataActions.failure(error));
      dispatch(FetchPromotionsActions.failure(error));
      dispatch(FetchRequiredOnboardingActions.failure(error));
      throw error;
    });
  };
};